import { ScrollTrigger } from 'gsap/ScrollTrigger';

export const initFunnel = (): void => {
  // Clear any existing ScrollTriggers for this section to prevent duplicates during Vite HMR
  ScrollTrigger.getAll().forEach(trigger => {
    if (trigger.trigger && ((trigger.trigger as HTMLElement).id === 'funnel-section' || (trigger.trigger as HTMLElement).id === 'funnel-wrapper')) {
      trigger.kill();
    }
  });

  const scrollParent = document.getElementById('funnel-scroll');
  const container = document.getElementById('funnel-container');
  const prevBtn = document.getElementById('funnel-prev');
  const nextBtn = document.getElementById('funnel-next');
  const overlayLeft = document.getElementById('funnel-overlay-left');
  const overlayRight = document.getElementById('funnel-overlay-right');

  if (!scrollParent || !container) return;

  // 1. Dynamic scroll amount helper based on card width + gap
  const getScrollAmount = (): number => {
    const card = container.querySelector('.funnel-card') as HTMLElement | null;
    const cardWidth = card ? card.getBoundingClientRect().width : 320;
    const gap = window.innerWidth >= 768 ? 48 : 24;
    return cardWidth + gap;
  };

  const scrollToStep = (direction: 1 | -1): void => {
    const amount = getScrollAmount();
    const maxScroll = scrollParent.scrollWidth - scrollParent.clientWidth;
    const nextLeft = Math.min(Math.max(scrollParent.scrollLeft + amount * direction, 0), maxScroll);

    scrollParent.scrollTo({ left: nextLeft, behavior: 'smooth' });
  };

  // 2. Navigation buttons click handlers
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      scrollToStep(-1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      scrollToStep(1);
    });
  }

  // 3. Dynamic Gradient Overlays handler
  const updateOverlays = () => {
    const { scrollLeft, scrollWidth, clientWidth } = scrollParent;
    
    if (overlayLeft) {
      if (scrollLeft > 10) {
        overlayLeft.classList.remove('opacity-0');
        overlayLeft.classList.add('opacity-100');
      } else {
        overlayLeft.classList.remove('opacity-100');
        overlayLeft.classList.add('opacity-0');
      }
    }

    if (overlayRight) {
      if (scrollLeft + clientWidth < scrollWidth - 10) {
        overlayRight.classList.remove('opacity-0');
        overlayRight.classList.add('opacity-100');
      } else {
        overlayRight.classList.remove('opacity-100');
        overlayRight.classList.add('opacity-0');
      }
    }
  };

  scrollParent.addEventListener('scroll', updateOverlays);
  
  // Run once on load/init to set initial overlay states
  updateOverlays();

  // Re-run overlay check on resize to ensure proper responsiveness
  window.addEventListener('resize', updateOverlays);

  // Horizontal movement is intentionally controlled by the arrow buttons.
};
